export default __webpack_public_path__ + "svg/calendar/2026/9/noviembre.svg?6a91e460";